import { Skeleton } from '@shared/components/ui/shadcn';

export const ProductsSkeleton = () => {
  return (
    <div className="p-4 space-y-4 mb-6 pb-6 gap-4 grid grid-cols-1 md:grid-cols-5 pt-4 border-b border-card-border">
      <div className="col-span-1 md:col-span-2">
        <Skeleton className="h-6 w-32 rounded-full mb-2 bg-hover-press" />
        <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
      </div>
      <div className="col-span-1 md:col-span-3 !mt-0">
        <div className="space-y-4">
          <div className="flex justify-end">
            <Skeleton className="h-10 w-40 rounded-md bg-hover-press" />
          </div>

          <div className="space-y-6">
            <div className="hidden md:grid md:grid-cols-12 gap-4 text-xs font-medium text-complementary-text border-b border-card-border pb-2">
              <Skeleton className="h-3 w-28 rounded-full col-span-6 bg-hover-press" />
              <Skeleton className="h-3 w-20 rounded-full col-span-3 bg-hover-press" />
              <Skeleton className="h-3 w-16 rounded-full col-span-2 bg-hover-press" />
              <div className="col-span-1"></div>
            </div>

            <div className="space-y-4">
              <div className="border-b border-card-border pb-4">
                <div className="hidden md:grid md:grid-cols-12 gap-4 items-center py-2">
                  <div className="col-span-6 flex items-center gap-3">
                    <Skeleton className="w-12 h-12 rounded-md bg-hover-press" />
                    <div className="space-y-2 flex-1">
                      <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
                      <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
                    </div>
                  </div>
                  <div className="col-span-3">
                    <Skeleton className="h-10 w-full bg-hover-press" />
                  </div>
                  <div className="col-span-2">
                    <Skeleton className="h-10 w-full bg-hover-press" />
                  </div>
                  <div className="col-span-1 flex justify-end">
                    <Skeleton className="h-6 w-6 rounded-full bg-hover-press" />
                  </div>
                </div>

                <div className="md:hidden space-y-3">
                  <div className="flex items-start gap-3">
                    <Skeleton className="w-10 h-10 rounded-md bg-hover-press" />
                    <div className="space-y-2 flex-1">
                      <Skeleton className="h-4 w-36 rounded-full bg-hover-press" />
                      <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <Skeleton className="h-10 flex-1 bg-hover-press" />
                    <Skeleton className="h-10 flex-1 bg-hover-press" />
                    <Skeleton className="h-6 w-6 rounded-full bg-hover-press" />
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-3 pt-2 border-t border-card-border">
              <div className="flex justify-between items-center text-sm pb-2 pt-3">
                <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
              </div>
              <div className="flex justify-between items-center text-sm gap-2">
                <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-24 rounded-md bg-hover-press" />
              </div>
              <div className="flex justify-between items-center text-sm gap-2">
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-24 rounded-md bg-hover-press" />
              </div>
              <div className="flex justify-between items-center text-lg font-bold pt-2 border-t border-card-border">
                <Skeleton className="h-5 w-16 rounded-full bg-hover-press" />
                <Skeleton className="h-5 w-24 rounded-full bg-hover-press" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
